import { combineReducers } from "redux";
import authReducer from "./authReducer";
import themeReducer from "./themeReducer";
import formWizardReducer from "../formWizardSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  theme: themeReducer,
  formWizard: formWizardReducer,
});

export default rootReducer;
